<template>
  <div class="confirmLoan">
    <div class="confirmLoan_bgc"></div>
    <div class="confirmLoan_box" :class="$store.state.user.isNested && 'nestedHeader'">
      <div class="confirmLoan_navbar">
        <Icon class="navbar_icon" name="arrow-left" @click="$router.back(1)"/>
        <span>{{ l.o_loan_nav_title }}</span>
      </div>

      <Popup position="bottom" :close-on-click-overlay="false" round v-model="show">
        <div class="popup_box">
          <img class="popup_box_close" @click="$router.back(1)" src="@/assets/home/guanbi2@2x.png" alt=""/>
          <div class="loanAmount">
            <img class="applyImg" src="@/assets/home/mon.png" alt=""/>
            <div class="title">{{ l.home_loan_limit }}</div>
            <div class="amount">NT$ {{ formatMoney(loanAmount) }}</div>
          </div>

          <div class="blocks">
            <div class="box" v-if="amount">
              <div class="title">{{ l.o_loan_to_the_account_amounts }}</div>
              <div class="desc">{{ amount }}</div>
            </div>
            <!--            <div class="box" v-if="repayAmount">-->
            <!--              <div class="title">{{ l.o_details_payment_amount_due }}</div>-->
            <!--              <div class="desc">{{ formatMoney(repayAmount) }}</div>-->
            <!--            </div>-->
            <!--            <div class="box" v-if="serviceFee">-->
            <!--              <div class="title">-->
            <!--                {{ l.o_item_service_fee }}-->
            <!--                <Icon @click="isShowPopup = true" name="warning-o"/>-->
            <!--              </div>-->
            <!--              <div class="desc">{{ formatMoney(serviceFee) }}</div>-->
            <!--            </div>-->
            <div class="box" v-if="payAmount">
              <div class="title">{{ l.home_payment_fee }}</div>
              <div class="desc">NT${{ formatMoney(payAmount) }}</div>
            </div>
            <div class="box" v-if="serviceAmount">
              <div class="title">{{ l.home_audit_consultation_fee }}</div>
              <div class="desc">NT${{ formatMoney(serviceAmount) }}</div>
            </div>
            <div class="box" v-if="riskAmount">
              <div class="title">{{ l.home_handling_fee }}</div>
              <div class="desc">NT${{ formatMoney(riskAmount) }}</div>
            </div>
            <!--            <div class="box" v-if="interest">-->
            <!--              <div class="title">{{ l.o_item_daily_interest }}</div>-->
            <!--              <div class="desc">{{ interest }}{{ l.home_unit_day }}</div>-->
            <!--            </div>-->
            <div class="box" v-if="loanTerm">
              <div class="title">{{ l.o_item_borrowing_cycle }}</div>
              <div class="desc">{{ loanTerm }}{{ l.home_unit_day }}</div>
            </div>
            <div class="box" v-if="accountName">
              <div class="title">{{ l.o_item_income }}</div>
              <div class="desc">{{ accountName }}</div>
            </div>
            <div class="box" v-if="bank">
              <div class="title">{{ l.o_item_beneficiary_bank }}</div>
              <div class="desc">{{ bank }}</div>
            </div>
            <div class="box" v-if="account">
              <div class="title">{{ l.o_item_receiving_account }}</div>
              <div class="desc">{{ account }}</div>
            </div>
          </div>
          <div class="diaMsg">*{{ l.home_loan_amount_msg }}</div>

          <div class="btnBox">
            <Button
                @click="showContractSignature = true"
                class="confirmLoanBtn"
                block
                type="info"
                native-type="submit"
            >{{ l.home_confirm_btn }}
            </Button
            >
          </div>
        </div>
      </Popup>
    </div>
    <CardPopup :show="isShowPopup" @closePopup="closePopup">
      <div class="popupContainer">
        <div class="popupTitle">{{ l.home_service_fees_include }}</div>
        <div class="popupDesc">
          <div class="popupItem">
            {{ l.home_payment_fee }}: {{ formatMoney(payAmount) }}
          </div>
          <div class="popupItem">
            {{ l.home_audit_consultation_fee }}:
            {{ formatMoney(serviceAmount) }}
          </div>
          <div class="popupItem">
            {{ l.home_handling_fee }}: {{ formatMoney(riskAmount) }}
          </div>
        </div>
      </div>
    </CardPopup>

    <CardPopup :show="popupLineShow" @closePopup="closeLinePopup">
      <div class="popupLineContainer">
        <div class="popupTitle">{{ l.home_click_line_account }}</div>
        <div class="popupDesc" @click="toLine">
          <img class="popupItem_img" src="@/assets/my/line.png" alt="">
          <div class="popupItem">
            https://lin.ee/{{ saasLoanappRes.mchLine }}
          </div>
        </div>
      </div>
    </CardPopup>

    <ContractSignature :show="showContractSignature" @confirmationSignature="confirmLoan"></ContractSignature>
  </div>
</template>

<script>
import {Icon, Toast, Popup} from "vant";
import l from "@/locales";
import {formatMoney} from "@/utils";
import buriedPoint from "@/mixins/buriedPoint";
import {saasLoanapp, saasConfirm} from "@/services/home";
import CardPopup from "@/components/cardPopup";
import ContractSignature from "@/components/contractSignature";
import {lrzUploadImage} from "@/services/upload";
// import { Decimal } from 'decimal.js'

export default {
  name: "confirmLoan",
  mixins: [buriedPoint],
  data() {
    return {
      popupLineShow: false,

      l: {
        ...l.home,
        ...l.repayMethods,
        ...l.orderItem,
        ...l.other,
        ...l.tabbar,
      },
      product: undefined,
      isShowPopup: false,

      amount: undefined,
      loanAmount: undefined,
      repayAmount: undefined,
      riskAmount: undefined,
      payAmount: undefined,
      serviceAmount: undefined,
      serviceFee: undefined,
      loanTerm: undefined,
      interest: undefined,
      bank: undefined,
      account: undefined,
      accountName: undefined,
      show: true,

      saasLoanappRes: {},

      showContractSignature: false,
    };
  },
  components: {Icon, CardPopup, Popup, ContractSignature},
  methods: {
    formatMoney,
    toLine() {
      // window.open("https://lin.ee/vomkBgS");
      window.location.href = "https://lin.ee/" + this.saasLoanappRes.mchLine;
    },
    closePopup() {
      this.isShowPopup = false;
    },
    closeLinePopup() {
      this.popupLineShow = false;
      this.$router.push("/order");
      // this.$router.push({path: "/detail", query: {busiId: this.saasLoanappRes.busiId}});
    },
    confirmLoan(file) {
          this.showContractSignature = false;
          let mchId = this.$route.query.mchId;
          let selectAmount = this.$route.query.selectAmount;
          console.log("confirmLoan");
          const params = {
            mchId,
            selectAmount,
          };
          saasLoanapp(params).then((res1) => {
            if (res1.code == 200) {
              this.saasLoanappRes = res1.result;
              this.homeBuriedPoint(localStorage.getItem("channel"));
              let loan_id = res1.result.loanId;
              this.$saveAppsFlyer(`申请贷款`, null, loan_id);

              lrzUploadImage(file, "uploadContract", (res) => {
                console.log("上传成功", res)
                if (res) {
                  console.log("1111111111")
                  Toast.success(this.l.home_toast_success);
                  setTimeout(() => {
                    this.popupLineShow = true;
                    // this.$router.push("/order");
                  }, 1000);
                }
              },res1.result.busiId);
            }
          });
    },
    async getConfirm() {
      let mchId = this.$route.query.mchId;
      let selectAmount = this.$route.query.selectAmount;
      let res = await saasConfirm({
        mchId,
        selectAmount,
      });
      this.product = res.result;
      this.initData();
    },
    init() {
      this.getConfirm();
    },
    initData() {
      let product = this.product;
      if (product) {
        this.amount = "NT$" + product.amount2Account; //$
        this.loanAmount = product.amount; //$
        this.repayAmount = "NT$" + product.paymentAmount; //$
        let feeRate = Number(product.fee.replace("%", "")) / 100;
        // let riskRate = Number(product.risk.replace("%", "")) / 100;
        // let payRate = Number(product.pay.replace("%", "")) / 100;
        // let serviceRate = Number(product.service.replace("%", "")) / 100;
        // this.riskAmount = new Decimal(product.amount).mul(new Decimal(riskRate))
        // this.payAmount = new Decimal(product.amount).mul(new Decimal(payRate))
        // this.serviceAmount = new Decimal(product.amount).mul(new Decimal(serviceRate))
        this.riskAmount = product.risk;
        this.payAmount = product.pay;
        this.serviceAmount = product.service;
        if (product.chargeType == "10") {
          this.serviceFee = "-NT$" + product.amount * feeRate;
        } else {
          this.serviceFee = "NT$" + product.amount * feeRate;
        }
        this.loanTerm = product.duration + " "; //天
        this.interest = product.rate + "/"; //天
        this.bank = product.bank_name;
        this.account = product.card_no;
        this.accountName = product.real_name;
      }
    },
  },
  activated() {
  },
  mounted() {
  },
  created() {
    this.init();
    // this.showContractSignature = true;
  },
};
</script>

<style lang="less" scoped>
@import "./confirm.less";
</style>
